/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable no-extend-native */
import { mathJaxToEnglish, mathJaxToEnglishAll } from '@suntex.fim/a11y';

declare global {
  interface String {
    /**
     * @deprecated use `mathJaxToEnglishAll` from `@suntex.fim/a11y`
     */
    mathJaxToEnglishAll(): string;
    /**
     * @deprecated use `mathJaxToEnglish` from `@suntex.fim/a11y`
     */
    mathJaxToEnglish(): string;

    /**
     * @deprecated use configurable logger for styled logging
     */
    log(): void;

    /**
     * @deprecated Use native `str === ''`
     */
    isBlank(): boolean;

    /**
     * @deprecated Use native `str !== ''`
     */
    isNotBlank(): boolean;

    /**
     * @deprecated Use native `choices.includes(str)` or `$$$(str).matches(...)` from `@suntex.core/text` instead.
     */
    isOneOf(...choices: string[]): boolean;
  }
}

String.prototype.mathJaxToEnglish = function () {
  return mathJaxToEnglish(this as string);
};
String.prototype.mathJaxToEnglishAll = function () {
  return mathJaxToEnglishAll(this as string);
};

String.prototype.log = function () {
  const styles = [
    'background: linear-gradient(#D33106, #571402)',
    'border: 1px solid #3E0E02',
    'color: white',
    'display: block',
    'text-shadow: 0 1px 0 rgba(0, 0, 0, 0.3)',
    'box-shadow: 0 1px 0 rgba(255, 255, 255, 0.4) inset, 0 5px 3px -5px rgba(0, 0, 0, 0.5), 0 -13px 5px -10px rgba(255, 255, 255, 0.4) inset',
    'line-height: 20px',
    'font-weight: bold',
    'padding: 0 5px',
  ].join(';');

  //var now = new Date().getTime();
  //var diff = now - todayMilliseconds;
  //console.log(`%c ${msToTime(diff)}: ${this.toString()}`, styles);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-console
  console.log(`%c ${this.toString()}`, styles);
};

String.prototype.isBlank = function (this: string) {
  return this.valueOf() === '';
};

String.prototype.isNotBlank = function (this: string) {
  return this.valueOf() !== '';
};

String.prototype.isOneOf = function (this: string, ...choices: string[]) {
  for (const choice of choices) {
    if (this == choice) return true;
  }

  return false;
};
